import { render } from "./OrgForm.vue?vue&type=template&id=45a56d7e&scoped=true&ts=true&lang=html"
import script from "./OrgForm.vue?vue&type=script&lang=ts"
export * from "./OrgForm.vue?vue&type=script&lang=ts"

import "./OrgForm.vue?vue&type=style&index=0&id=45a56d7e&scoped=true&lang=css"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a56d7e"]])

export default __exports__